import React from "react";

const QuickActions = () => (
  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))",gap:16}}>
    <button className="btn btn-primary">Add New User</button>
    <button className="btn btn-secondary">View All Users</button>
    <button className="btn btn-secondary">Generate Reports</button>
    <button className="btn btn-secondary">Manage Training Modules</button>
  </div>
);

export default QuickActions;
